import { Injector, NgModule } from '@angular/core';
import { EyeWatchRoutingModule } from './eyewatch-routing.module';
import { EyeWatchBootstrapModule } from './eyewatch-bootstrap.module';
import { MenuService } from '@kaiser-software/chassis-core';

@NgModule({
    imports: [
        EyeWatchBootstrapModule,
        EyeWatchRoutingModule
    ],
    exports: [
        EyeWatchBootstrapModule
    ]
})
export class EyeWatchModule {

    constructor(private menu: MenuService, injector: Injector) {
        console.log('Eye Watch module bootstrapped.');

        // Remove settings menu items
        const sidebar = menu.get('sidebar');

        sidebar.delete('config');
        sidebar.delete('settings');
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/eyewatch.module.ts